<template>
  <div class="flex items-center justify-center mb-24 max-w-7xl mx-auto mt-8 px-4">
    <new-logo />
  </div>
</template>

<script>
import NewLogo from './Logo.vue';

export default {
  components: {
    NewLogo,
  },
};
</script>
